
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.333 25.456C25.89 21.834 30.573 20 35.259 20s9.37 1.834 12.927 5.456l3.198 3.252 3.171-3.225c7.116-7.247 18.766-7.247 25.881 0 7.115 7.246 7.115 18.957 0 26.203-9.076 9.241-18.147 18.467-27.224 27.708a2.574 2.574 0 01-1.841.773 2.585 2.585 0 01-1.84-.773L22.332 51.66c-7.105-7.25-7.116-18.957 0-26.203z"}})])
          )
        }
      }
    